export default [
  {
    name: 'electricity',
    labelKey: 'search.filter.bill_electricity',
    tracking: 'ga-search-form-electricity'
  },
  {
    name: 'wifi',
    labelKey: 'search.filter.bill_wifi',
    tracking: 'ga-search-form-wifi'
  },
  {
    name: 'water',
    labelKey: 'search.filter.bill_water',
    tracking: 'ga-search-form-water'
  },
  {
    name: 'cleaning_service',
    labelKey: 'search.filter.bill_cleaning_service',
    tracking: 'ga-search-form-cleaning-service'
  },
  {
    name: 'gas',
    labelKey: 'search.filter.bill_gas',
    tracking: 'ga-search-form-gas'
  },
  {
    name: 'meal_service',
    labelKey: 'search.filter.bill_meal_service',
    tracking: 'ga-search-form-meal-service'
  },
  {
    name: 'central_heat',
    labelKey: 'search.filter.bill_central_heat',
    tracking: 'ga-search-form-central-heat'
  },
  {
    name: 'bed_linen',
    labelKey: 'search.filter.bill_bed_linen',
    tracking: 'ga-search-form-bed-linen'
  },
  {
    name: 'council_tax',
    labelKey: 'search.filter.bill_council_tax',
    tracking: 'ga-search-form-council-tax'
  }
];
